// Zones d'intervention - chaque zone a sa page SEO dédiée
export const ZONES = [
  {
    slug: "paris-ile-de-france",
    dept: "75 · 77 · 78 · 91 · 92 · 93 · 94 · 95",
    short: "Paris & IDF",
    name: "Paris & Île-de-France",
    nameShort: "Île-de-France",
    path: "/",
    tagline: "Serrurier d'urgence à Paris et en Île-de-France",
    metaDesc: "Serrurier 24h/24 à Paris et en Île-de-France. Intervention en moins de 30 min, devis gratuit.",
    cities: [
      "Paris 1er", "Paris 2e", "Paris 3e", "Paris 4e", "Paris 5e",
      "Paris 6e", "Paris 7e", "Paris 8e", "Paris 9e", "Paris 10e",
      "Paris 11e", "Paris 12e", "Paris 13e", "Paris 14e", "Paris 15e",
      "Paris 16e", "Paris 17e", "Paris 18e", "Paris 19e", "Paris 20e",
      "Boulogne-Billancourt", "Saint-Denis", "Argenteuil", "Montreuil",
      "Nanterre", "Courbevoie", "Versailles", "Vitry-sur-Seine",
      "Créteil", "Colombes", "Asnières-sur-Seine", "Aulnay-sous-Bois",
      "Rueil-Malmaison", "Champigny-sur-Marne", "Saint-Maur-des-Fossés",
      "Drancy", "Issy-les-Moulineaux", "Noisy-le-Grand", "Levallois-Perret",
      "Cergy", "Antony", "Neuilly-sur-Seine", "Clichy", "Ivry-sur-Seine",
      "Sarcelles", "Pantin", "Le Blanc-Mesnil", "Maisons-Alfort",
      "Chelles", "Évry-Courcouronnes", "Meaux", "Villejuif",
      "Bobigny", "Épinay-sur-Seine", "Fontenay-sous-Bois", "Bondy",
      "Savigny-sur-Orge", "Clamart", "Sartrouville", "Vincennes",
      "Suresnes", "Puteaux", "Bagneux", "Saint-Ouen", "Melun",
      "Alfortville", "Aubervilliers", "Poissy", "Massy",
    ],
  },
  {
    slug: "eure-et-loir-28",
    dept: "28",
    short: "Eure-et-Loir",
    name: "Eure-et-Loir (28)",
    nameShort: "Eure-et-Loir",
    path: "/serrurier-eure-et-loir-28",
    tagline: "Serrurier d'urgence en Eure-et-Loir (28)",
    metaDesc: "Serrurier 24h/24 en Eure-et-Loir. Chartres, Dreux, Châteaudun, Lucé. Intervention rapide, devis gratuit.",
    cities: [
      "Chartres", "Dreux", "Châteaudun", "Lucé", "Mainvilliers",
      "Nogent-le-Rotrou", "Vernouillet", "Vernouillet", "Le Coudray",
      "Épernon", "Auneau", "Anet", "Brezolles", "La Loupe", "Illiers-Combray",
      "Maintenon", "Bonneval", "Cloyes-sur-le-Loir", "Senonches", "Courville-sur-Eure",
    ],
  },
  {
    slug: "eure-27",
    dept: "27",
    short: "Eure",
    name: "Eure (27)",
    nameShort: "Eure",
    path: "/serrurier-eure-27",
    tagline: "Serrurier d'urgence dans l'Eure (27)",
    metaDesc: "Serrurier 24h/24 dans l'Eure. Évreux, Vernon, Louviers, Pont-Audemer. Intervention rapide, devis gratuit.",
    cities: [
      "Évreux", "Vernon", "Louviers", "Val-de-Reuil", "Pont-Audemer",
      "Gaillon", "Gisors", "Bernay", "Les Andelys", "Verneuil-sur-Avre",
      "Pacy-sur-Eure", "Conches-en-Ouche", "Breteuil", "Brionne", "Beaumont-le-Roger",
      "Rugles", "Saint-André-de-l'Eure", "Charleval", "Le Neubourg", "Étrépagny",
    ],
  },
  {
    slug: "loiret-45",
    dept: "45",
    short: "Loiret",
    name: "Loiret (45)",
    nameShort: "Loiret",
    path: "/serrurier-loiret-45",
    tagline: "Serrurier d'urgence dans le Loiret (45)",
    metaDesc: "Serrurier 24h/24 dans le Loiret. Orléans, Montargis, Gien, Pithiviers. Intervention rapide, devis gratuit.",
    cities: [
      "Orléans", "Olivet", "Saint-Jean-de-Braye", "Saint-Jean-de-la-Ruelle",
      "Fleury-les-Aubrais", "Montargis", "Gien", "Pithiviers", "Chalette-sur-Loing",
      "Amilly", "Villemandeur", "Saran", "Ingré", "Chécy", "Sully-sur-Loire",
      "Beaugency", "Meung-sur-Loire", "Briare", "Neuville-aux-Bois", "Châteauneuf-sur-Loire",
    ],
  },
  {
    slug: "oise-60",
    dept: "60",
    short: "Oise",
    name: "Oise (60)",
    nameShort: "Oise",
    path: "/serrurier-oise-60",
    tagline: "Serrurier d'urgence dans l'Oise (60)",
    metaDesc: "Serrurier 24h/24 dans l'Oise. Beauvais, Compiègne, Creil, Senlis. Intervention rapide, devis gratuit.",
    cities: [
      "Beauvais", "Compiègne", "Creil", "Nogent-sur-Oise", "Senlis",
      "Méru", "Chantilly", "Pont-Sainte-Maxence", "Clermont", "Noyon",
      "Crépy-en-Valois", "Montataire", "Liancourt", "Gouvieux", "Breuil-le-Vert",
      "Mouy", "Grandvilliers", "Auneuil", "Lamorlaye", "Chambly",
    ],
  },
];

export const DEFAULT_ZONE = ZONES[0];

export function getZoneBySlug(slug) {
  return ZONES.find((z) => z.slug === slug) || DEFAULT_ZONE;
}
